.me-dropdown__menu:has(dropdown-menu-type-2) {
  padding: 0;

  @include desktop {
    position: absolute;
    top: 100%;
    padding: 0;
    margin: 0;
    border: none;
    transform: none;
    background: inherit;
  }
}

.dropdown-menu-type-2 {
  @include desktop {
    position: relative;
    left: 0;
    right: 0;
    z-index: 1001;
    margin: 0;
    transform: none;
  }

  &__wrapper {
    @include desktop {
      width: 100vw;
      max-width: 100vw;
      background: var(--background-color-primary);
      border-radius: 0;
      border-bottom: var(--border-size-sm) solid var(--border-color-primary);
      border-left: none;
      border-right: none;
      overflow: visible;
      box-shadow: 0 4px 12px rgb(44 44 44 / 12%);
    }
  }

  &__container {
    @include desktop {
      @include container;
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-2xl);

    @include desktop {
      flex-direction: row;
      padding-top: 0;
      gap: 0;
      border-bottom: var(--border-size-sm) solid var(--color-neutral-neutral-lightest);
    }
  }

  &__navigation {
    @include desktop {
      display: flex;
      flex-direction: row;
      gap: var(--spacing-md);
      flex: 0 0 65%;
      max-width: 65%;
      padding: var(--spacing-2xl) 0 calc(var(--spacing-2xl) + var(--spacing-lg));
    }

    @include above($breakpoint-desktop-md) {
      gap: var(--spacing-2xl);
    }

    @include above($media-desktop) {
      gap: var(--spacing-6xl);
    }

    .dropdown-menu-type-2__navigation-item {
      &:nth-child(n + 3) {
        @include desktop {
          margin-left: calc(map-get($map: $spacings, $key: md) / -1);
        }

        @include above($breakpoint-desktop-md) {
          margin-left: calc(map-get($map: $spacings, $key: 2xl) / -1);
        }

        @include above($media-desktop) {
          margin-left: calc(map-get($map: $spacings, $key: 6xl) / -1);
        }
      }
    }
  }

  &__navigation-item {
    @include desktop {
      flex: 1 1 0;
      min-width: 0;
    }

    [slot='navigation-group'] {
      display: flex;
      flex-direction: column;

      > me-button:not(:last-child) {
        margin-bottom: var(--spacing-xl);
      }

      @include desktop {
        display: block;
      }
    }

    .me-heading {
      margin-bottom: var(--spacing-md);

      @include desktop {
        margin-bottom: calc(var(--spacing-xl) + var(--spacing-2xs));
      }
    }
  }

  &__element-item {
    &:not(:last-child) {
      margin-bottom: calc(var(--spacing-xl) + var(--spacing-sm));
    }

    .me-button {
      white-space: normal;

      .me-icon.me-button__icon {
        height: 24px;
        width: 24px;
      }
    }
  }

  &__description {
    margin-left: calc(var(--spacing-2xl) + var(--spacing-2xs));
    font-size: map-get($font-sizes, sm);
    color: var(--color-neutral-neutral-dark);
    line-height: map-get($line-heights, lg);
  }

  &__featured {
    position: relative;
    background: var(--background-color-secondary);
    padding: var(--spacing-md);

    @include desktop {
      flex: 0 0 35%;
      max-width: 35%;
      padding: var(--spacing-2xl) 0 calc(var(--spacing-2xl) + var(--spacing-lg)) var(--spacing-2xl);
      display: flex;
      flex-direction: column;
      gap: var(--spacing-md);
    }

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 100%;
      width: 9999px;
      height: 100%;
      background: var(--background-color-secondary);
    }

    .me-heading {
      margin-bottom: calc(var(--spacing-xl) + var(--spacing-2xs));
      font-size: map-get($font-sizes, sm);
    }
  }

  &__featured-cards {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-2xl);
    white-space: normal;
    margin-bottom: calc(var(--spacing-xl) + var(--spacing-xs));

    @include above($breakpoint-desktop-md) {
      gap: var(--spacing-xl);
    }
  }

  &__featured-card {
    .featured-card__content {
      display: flex;
      flex-direction: column;
      gap: var(--spacing-sm);
      align-items: flex-start;

      @include above($breakpoint-desktop-md) {
        flex-direction: row;
        gap: var(--spacing-xl);
      }
    }

    .featured-card__image {
      max-width: 100px;
      overflow: hidden;

      @include above($breakpoint-desktop-md) {
        max-width: 160px;
      }
    }

    .featured-card__text {
      flex: 1;
      min-width: 0;
    }

    .featured-card__title {
      margin-top: var(--spacing-2xs);
      font-size: map-get($font-sizes, md);
      font-weight: map-get($font-weights, semi-bold);
      color: var(--color-neutral-neutral-dark);
    }

    .featured-card__description {
      margin-top: var(--spacing-xs);
      margin-bottom: var(--spacing-xs);
      font-size: map-get($font-sizes, sm);
      line-height: map-get($line-heights, lg);
      color: var(--color-neutral-neutral);
    }

    .featured-card__action {
      font-size: map-get($font-sizes, sm);
      color: var(--link-color-brand-primary);
      font-weight: map-get($font-weights, medium);
      text-decoration: none;

      &:hover {
        color: var(--color-brand-primary-dark);
      }
    }
  }

  @include below($breakpoint-desktop) {
    &__featured-card {
      .featured-card__image {
        max-width: 100%;
      }
    }
  }

  &__featured:not(:has(*)) {
    display: none;
  }
}

.me-dropdown {
  .dropdown-menu-type-2 {
    .me-button {
      white-space: normal;
    }
  }
}
